import { trackEvent } from "@/hooks/use-analytics";

const StickyCta = () => (
  <a
    href="#tickets"
    onClick={() => trackEvent("select_content", { content_type: "cta", content_id: "sticky_get_tickets" })}
    className="fixed bottom-8 right-8 z-50 bg-gold text-ink shadow-[0_10px_30px_rgba(0,0,0,0.3)] hover:-translate-y-1 transition-transform active:scale-[0.95] font-sans font-bold uppercase"
    style={{
      fontSize: "var(--cta-size, 0.75rem)",
      letterSpacing: "var(--cta-tracking, 0.1em)",
      padding: "var(--cta-padding, 1rem 2rem)",
      borderRadius: "var(--cta-radius, 999px)",
    }}
  >
    Get Tickets Now
  </a>
);

export default StickyCta;
